const table = [
  {
      prop: 'name',
      label: 'Nombres',
      minWidth: 120
  },
  {
      prop: 'username',
      label: 'Usuario',
      minWidth: 110
  },
  {
      prop: 'email',
      label: 'Correo',
      minWidth: 220
  },
  {
      prop: 'role_name',
      label: 'Perfil',
      minWidth: 150
  }
]

export default table
